import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { Card, CardBody, Col, Row } from "reactstrap";
import { widgetDataApp } from "../../../common/data";

import PropTypes from "prop-types";
import { withRouter, Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Loader from "../../../Components/Common/Loader";

const WidgetAdmin = ( props ) =>
{
  const [ widgetData, setWidgetData ] = useState( [] );

  useEffect( () =>
  {
    const fetchData = async () =>
    {
      const getWidgetData = await widgetDataApp( props.periode );
      setWidgetData( getWidgetData );
    };

    fetchData();
  }, [ props.periode ] );

  return (
    <Col md={ 12 } xl={ 6 }>
      <Row>
        { widgetData.length > 0 ? (
          widgetData.map( ( item, key ) => (
            <Col md={ 6 } key={ key }>
              <Card className="card-animate card-height-100">
                <CardBody>
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                        { props.t( item.label ) }
                      </p>
                    </div>
                  </div>
                  <div className="d-flex align-items-end justify-content-between mt-4">
                    <div>
                      <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                        <span className="counter-value" data-target="559.25">
                          <CountUp
                            start={ 0 }
                            prefix={ item.prefix }
                            suffix={ item.suffix }
                            separator={ item.separator }
                            end={ item.counter }
                            decimals={ item.decimals }
                            duration={ 4 }
                          />
                        </span>
                      </h4>
                      <Link
                        to={ item.location }
                        className="text-decoration-underline"
                      >
                        { props.t( item.link ) }
                      </Link>
                    </div>
                    <div className="avatar-sm flex-shrink-0">
                      <span
                        className={
                          "avatar-title rounded fs-3 bg-soft-" + item.bgcolor
                        }
                      >
                        <i
                          className={ `text-${ item.bgcolor } ${ item.icon }` }
                        ></i>
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ) )
        ) : (
          <>
            <Col md={ 12 }>
              <Card className="h-100 w-100">
                <CardBody>
                  <div className="text-center my-3">
                    <Loader style={ { color: "#014c94" } } />
                    <h2>Chargement...</h2>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </>
        ) }
      </Row>
    </Col>
  );
};

WidgetAdmin.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter( withTranslation()( WidgetAdmin ) );
